import * as React from "react";
const PointerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <mask
      id="aPointerIcon"
      width={20}
      height={21}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 .5h20v20H0z" />
    </mask>
    <g mask="url(#aPointerIcon)">
      <path
        fill={props.fill}
        d="M5.833 18v-1.667h3.334V13.75a4.475 4.475 0 0 1-1.823-.865 3.733 3.733 0 0 1-1.177-1.593 4.045 4.045 0 0 1-2.615-1.365A4.01 4.01 0 0 1 2.5 7.167v-.834c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h1.666V3h8.334v1.667h1.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.176v.834a4.01 4.01 0 0 1-1.052 2.76 4.045 4.045 0 0 1-2.615 1.365 3.732 3.732 0 0 1-1.177 1.593 4.474 4.474 0 0 1-1.823.865v2.583h3.334V18H5.833Zm0-8.5V6.333H4.167v.834c0 .527.152 1.003.458 1.427.306.423.708.725 1.208.906ZM10 12.167c.694 0 1.285-.243 1.77-.73.487-.486.73-1.076.73-1.77v-5h-5v5c0 .694.243 1.284.73 1.77.485.487 1.076.73 1.77.73ZM14.167 9.5c.5-.18.902-.483 1.208-.906.306-.424.458-.9.458-1.427v-.834h-1.666V9.5Z"
      />
    </g>
  </svg>
);
export default PointerIcon;
